import React from 'react'
import { createCopyrightText } from './__utils__'
import PropTypes from 'prop-types'

export default function FooterLink({
  href,
  text,
  target,
  className,
  onClick,
  ...rest
}) {
  return href ? (
    <a
      href={href}
      target={target}
      data-pa-click={`Footer-Link-${text}`}
      onClick={onClick}
      className={className}
      {...rest}
    >
      {text}
    </a>
  ) : (
    <span>{createCopyrightText(text)}</span>
  )
}

FooterLink.propTypes = {
  href: PropTypes.string,
  text: PropTypes.string,
  target: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
}
